module.exports = __webpack_public_path__ + "img/traininglukas.5cdbbd5b.jpg";